<section>
  <article class="container">
    <div class="row">
      <div class="col-12">
        <div class="tab-content" id="pills-tabContent">
          <!-- Expedientes -->
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div class="container">
              <div class="row mt-5">
                <div
                  *ngFor="let item of expedientes_list"
                  class="col-12 col-md-6 offset-0"
                >
                  <div class="row d-flex align-items-center hoverable-item">
                    <div class="col-4">
                      <img
                        class="w-100"
                        src="./assets/imgs/proximos2.webp"
                        alt="Próximos viajes"
                      />
                    </div>
                    <div class="col-8">
                      <h3>
                        Exp. {{ item.id }} - {{ item.destinos | titlecase }}
                      </h3>
                      <small
                        >{{ item.fecha_inicio | date: "dd/MM/yyyy" }} -
                        {{ item.fecha_fin | date: "dd/MM/yyyy" }}</small
                      >
                      <p>{{ item.boletos }}</p>
                      <div class="row">
                        <div class="col">
                          <a routerLink="/detalle-expediente/{{ item.id }}"
                            >Ver detalles</a
                          >
                        </div>
                        <div class="col">
                          <a routerLink="/archivos-expediente/{{ item.id }}"
                            >Ver documentos</a
                          >
                        </div>
                        <div class="col"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</section>
